"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _map = _interopRequireDefault(require("currency-symbol-map/map"));

var _Cancel = _interopRequireDefault(require("@material-ui/icons/Cancel"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _LocationOn = _interopRequireDefault(require("@material-ui/icons/LocationOn"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _styles = require("@material-ui/core/styles");

var _TextField = _interopRequireDefault(require("./TextField.css"));

/**
 * These are all of the valid characters we can put as a currency symbol,
 * as our frontend retrieves symbols from this same table.
 */
var currencySymbols = function currencySymbols() {
  var values = [];
  var key = '';
  /**
   * This will repeat some symbols, but the computation power
   * needed to make the list unique is not worth it.
   */

  for (key in _map.default) {
    values = [].concat((0, _toConsumableArray2.default)(values), [_map.default[key]]);
  }

  return values;
};

var TextField =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TextField, _React$PureComponent);

  function TextField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TextField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderIcon", function (name, iconClass) {
      switch (name) {
        case 'search':
          return React.createElement(_Search.default, {
            className: iconClass
          });

        case 'location':
          return React.createElement(_LocationOn.default, {
            className: iconClass
          });
        // This case covers all of the currency symbols.

        default:
          return name;
      }
    });
    return _this;
  }

  (0, _createClass2.default)(TextField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          disabled = _this$props.disabled,
          errorText = _this$props.errorText,
          fullWidth = _this$props.fullWidth,
          icon = _this$props.icon,
          iconPlacement = _this$props.iconPlacement,
          label = _this$props.label,
          multiline = _this$props.multiline,
          name = _this$props.name,
          _onChange = _this$props.onChange,
          onClear = _this$props.onClear,
          outline = _this$props.outline,
          placeholder = _this$props.placeholder,
          rounded = _this$props.rounded,
          showClearLength = _this$props.showClearLength,
          type = _this$props.type,
          value = _this$props.value; // If we are masking our clear button, we should let the user know.

      if (icon && iconPlacement === 'right' && value && onClear && !!showClearLength) {
        console.warn("TextField: The clear button may be getting masked by a custom icon on the right.\n      Ensure that your properties are correct.");
      }

      return React.createElement(_FormControl.default, {
        fullWidth: fullWidth
      }, label && React.createElement(_InputLabel.default, {
        shrink: true,
        htmlFor: name,
        className: classes.inputLabel
      }, React.createElement(_Typography.default, {
        variant: 'caption',
        className: classes.inputLabelTypography
      }, label)), React.createElement(_InputBase.default, {
        fullWidth: fullWidth,
        multiline: multiline,
        disabled: disabled,
        error: !!errorText && !disabled,
        name: name,
        value: value,
        placeholder: placeholder,
        classes: {
          root: "".concat(classes.root, " ").concat(rounded ? 'rounded' : 'squared', " ").concat(fullWidth ? 'full-width' : '', " ").concat(outline && 'outline'),
          input: "".concat(classes.input, " ").concat(icon && iconPlacement === 'left' ? 'icon-left' : '', " ").concat(rounded ? 'rounded' : 'squared'),
          disabled: classes.disabled,
          error: classes.error
        },
        type: type,
        startAdornment: icon && iconPlacement === 'left' && React.createElement(_InputAdornment.default, {
          position: "end"
        }, this.renderIcon(icon, classes.icon)),
        endAdornment: icon && iconPlacement === 'right' ? React.createElement(_InputAdornment.default, {
          position: "start"
        }, this.renderIcon(icon, classes.icon)) : !disabled && value && onClear && !!showClearLength && value.length >= showClearLength && React.createElement(_InputAdornment.default, {
          className: classes.clear,
          onClick: onClear,
          position: "start"
        }, React.createElement(_Cancel.default, {
          className: "".concat(classes.icon, " close")
        })),
        onChange: function onChange(e) {
          return _onChange(e, e.target.value);
        }
      }), errorText && !disabled && React.createElement(_Typography.default, {
        variant: 'error',
        className: classes.errorText
      }, errorText));
    }
  }]);
  return TextField;
}(React.PureComponent);

TextField.defaultProps = {
  disabled: false,
  fullWidth: false,
  icon: null,
  iconPlacement: 'left',
  label: null,
  multiline: false,
  onClear: null,
  outline: true,
  placeholder: '',
  rounded: false,
  showClearLength: 0,
  type: 'text',
  value: ''
};
TextField.propTypes = {
  /**
   * If `true`, the TextField will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Error text: is shown when TextField value is incorrect
   */
  errorText: PropTypes.string,

  /**
   * Whether the TextField is full width or not.
   * Defaults to false.
   */
  fullWidth: PropTypes.bool,

  /**
   * Input icon
   */
  icon: PropTypes.oneOf(['search', 'location', '%'].concat((0, _toConsumableArray2.default)(currencySymbols()))),

  /**
   * Input icon placement
   */
  iconPlacement: PropTypes.oneOf(['left', 'right']),

  /**
   * TextField label
   */
  label: PropTypes.string,

  /**
   * Whether the TextField functions as a textarea or not.
   */
  multiline: PropTypes.bool,

  /**
   * The name of the TextField
   */
  name: PropTypes.string,

  /**
   * Function fires on change TextField value.
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Function fires on click clear Textbox value.
   */
  onClear: PropTypes.func,

  /**
   * Whether the TextField has an outline. Defaults to true
   */
  outline: PropTypes.bool,

  /**
   * TextField placeholder
   */
  placeholder: PropTypes.string,

  /**
   * Whether the TextField is rounded or not.
   * Defaults to false.
   */
  rounded: PropTypes.bool,

  /**
   * Min TextField value lenght to show clear icon
   *  0 - never show up
   */
  showClearLength: PropTypes.number,

  /**
   * Type in input
   */
  type: PropTypes.oneOf(['text', 'password']),

  /**
   * Value of the Textbox
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

var _default = (0, _styles.withStyles)(_TextField.default)(TextField);

exports.default = _default;